@if ({
  components: components$ | async,
  }; as content) {
  @if (content.components) {
    <cx-breadcrumb [customCrumbs]="content.components || []"></cx-breadcrumb>
  } @else {
    <cx-breadcrumb [customCrumbs]="[]"></cx-breadcrumb>
  }
}
